import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'jhi-notification',
    templateUrl: './notification.component.html',
    styleUrls: []

})
export class NotificationComponent implements OnInit {
    constructor(
    ) {
    }

    ngOnInit() {
        var a = 1;
    }
}
